export const startCartPositioning = (() => {
    const settings = {
      elements: {
        cartHeader: {
          element: null,
          selector: null,
          resizeObserver: null,
          cssVariable: "--js-cartHeaderHeight",
        },
        cartBody: { element: null, selector: null },
        cartFooter: { element: null, selector: null },
        pageFooter: {
          element: null,
          selector: null,
          resizeObserver: null,
          cssVariable: "--js-pageFooterHeight",
        },
      },
      mutationObserver: {
        observer: null,
        options: { attributes: true, childList: true, subtree: true },
      },
    };
  
    const setSelectors = (
      cartHeaderElementSelector,
      cartBodyElementeSlector,
      cartFooterElementSelector,
      pageFooterElementSelector
    ) => {
      settings.elements.cartHeader.selector = cartHeaderElementSelector;
      settings.elements.cartBody.selector = cartBodyElementeSlector;
      settings.elements.cartFooter.selector = cartFooterElementSelector;
      settings.elements.pageFooter.selector = pageFooterElementSelector;
    };
  
    const setElements = () => {
      for (const [key, value] of Object.entries(settings.elements)) {
        if (
          document.querySelector(value.selector) !== null &&
          settings.elements[key].element !==
            document.querySelector(value.selector)
        ) {
          settings.elements[key].element = document.querySelector(value.selector);
          if (
            settings.elements[key] &&
            "resizeObserver" in settings.elements[key]
          ) {
            settings.elements[key].resizeObserver = createResizeObserver(
              key,
              settings.elements[key].element,
              settings.elements[key].cssVariable
            );
          }
        }
      }
    };
  
    const createMutationObserver = () => {
      settings.mutationObserver.observer = new MutationObserver(
        (mutationList, observer) => {
          for (const mutation of mutationList) {
            setElements();
          }
        }
      );
  
      settings.mutationObserver.observer.observe(
        document.body,
        settings.mutationObserver.options
      );
    };
  
    const createResizeObserver = (key, target, cssVariable) => {
      settings.elements[key].resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          let height = entry.borderBoxSize[0].blockSize + "px";
          document.querySelector(":root").style.setProperty(cssVariable, height);
        }
      });
      settings.elements[key].resizeObserver.observe(target);
    };
  
    const init = (
      cartHeaderElementSelector,
      cartBodyElementeSlector,
      cartFooterElementSelector,
      pageFooterElementSelector
    ) => {
      setSelectors(
        cartHeaderElementSelector,
        cartBodyElementeSlector,
        cartFooterElementSelector,
        pageFooterElementSelector
      );
  
      // setElements();
      createMutationObserver();
    };
  
    const getSettings = () => {
      return settings;
    };
  
    return {
      init: init,
      getSettings: getSettings,
    };
  })();